import type { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';

export default (theme: Theme) =>
    createStyles({
        styleOverrides: {
            root: {},
            toolbar: {
                justifyContent: 'space-between',
                padding: '8px',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
            spacer: { display: 'none' },
            caption: {
                color: theme.palette.semantic.colorForegroundDeEmp,
                fontSize: '14px',
                '&:first-of-type': { display: 'none' },
            },
            selectLabel: { order: 3 },
            selectRoot: {
                order: 3,
                marginRight: '0px',
                '&:before': {
                    color: theme.palette.semantic.colorForegroundDisable,
                    whiteSpace: 'nowrap',
                },

                '&:focus-within': { outline: 'auto' },
            },
            actions: {
                flex: 1,
                order: 2,
            },
        },
    });
